export const formatDate = (dateString) => {
  const date = new Date(dateString);
  const options = {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: true
  };
  return date.toLocaleDateString('en-US', options);
};

export const formatDuration = (seconds) => {
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = seconds % 60;
  return `${minutes}:${remainingSeconds.toString().padStart(2, '0')}`;
};

export const getCallTypeLabel = (callType) => {
  const labels = {
    'call_out': 'Call out',
    'call_in': 'Call in',
    'outgoing': 'Call out',
    'incoming': 'Call in'
  };
  return labels[callType] || callType;
};

export const getStatusColor = (status) => {
  const colors = {
    'completed': '#28a745',
    'failed': '#dc3545',
    'no_answer': '#ffc107',
    'busy': '#fd7e14',
    'rejected': '#dc3545',
    'canceled': '#6c757d'
  };
  return colors[status] || '#6c757d';
};

export const calculateDateRange = (rangeType) => {
  const endDate = new Date();
  let startDate = new Date();

  switch (rangeType) {
    case 'Last 7 Days':
      startDate.setDate(endDate.getDate() - 7);
      break;
    case 'Last 30 Days':
      startDate.setDate(endDate.getDate() - 30);
      break;
    case 'Last 3 Months':
      startDate.setMonth(endDate.getMonth() - 3);
      break;
    default:
      startDate.setDate(endDate.getDate() - 7);
  }

  return {
    start_date: startDate.toISOString().split('T')[0],
    end_date: endDate.toISOString().split('T')[0]
  };
};